module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/pod.ba954328.svg";